import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TravelXNewState } from 'src/app/travelxnew/store/state/travelxnew.state';
import { travelXNewFeatureKey } from 'src/app/travelxnew/store/selectors';

export const travelxNewFeature = createFeatureSelector<TravelXNewState>(travelXNewFeatureKey);

// Loading selectors
export const selectLoading = createSelector(travelxNewFeature, (state) => state.orientations.loading);
export const selectOverviewLoading = createSelector(travelxNewFeature, (state) => state.orientations.overviewLoading);
export const selectComplianceLoading = createSelector(
    travelxNewFeature,
    (state) => state.orientations.complianceLoading
);
export const selectPayrollLoading = createSelector(travelxNewFeature, (state) => state.orientations.payrollLoading);
export const selectHousingLoading = createSelector(travelxNewFeature, (state) => state.orientations.housingLoading);
export const selectBenefitLoading = createSelector(travelxNewFeature, (state) => state.orientations.benefitLoading);
export const selectFacilityLoading = createSelector(travelxNewFeature, (state) => state.orientations.facilityLoading);

export const selectOrientationContracts = createSelector(travelxNewFeature, (state) => state.orientations.contracts);
export const getSelectedContract = createSelector(travelxNewFeature, (state) => state.orientations.selectedContract);
export const getExpandedSectionState = createSelector(
    travelxNewFeature,
    (state) => state.orientations.expandedSectionState
);
// Sections selectors
export const selectOverview = createSelector(travelxNewFeature, (state) => state.orientations.overview);
export const selectCompliance = createSelector(travelxNewFeature, (state) => state.orientations.compliance);
export const selectPayroll = createSelector(travelxNewFeature, (state) => state.orientations.payroll);
export const selectHousing = createSelector(travelxNewFeature, (state) => state.orientations.housing);
export const selectBenefit = createSelector(travelxNewFeature, (state) => state.orientations.benefit);
export const selectFacility = createSelector(travelxNewFeature, (state) => state.orientations.facility);
